<div class="sidebar" [ngClass]="{ 'sidebar-collapsed': isSidebarCollapsed }">
  <button class="sidebar-toggle-btn" [ngClass]="{ 'sidebar-collapsed': isSidebarCollapsed }"
    (click)="onSidebarToggle()">
    <mat-icon [fontIcon]="isSidebarCollapsed ? 'navigate_next' : 'navigate_before'"></mat-icon>

  </button>

  <!-- <div class="sidebar-header">
  <a href="#" class="sidebar-logo">{{
    isSidebarCollapsed ? 'C' : 'CodeWithChintan'
  }}</a>
</div> -->
<div class="sidebar-menu">
  <ul>
    @for (item of menuItems; track item) {
      <li class="sidebar-menu-item ">
        <a [routerLink]="item.route" class="sidebar-item "
          [ngClass]="{ 'sidebar-item-active': activeRoute === item.route }">
          @if (item.iconType === 'mat') {
            <mat-icon class="sidebar-item-icon" [fontIcon]="item.icon"></mat-icon>
          }
          @if (item.iconType === 'other') {
            <img class="sidebar-item-icon" [src]="item.icon" alt="{{ item.label }}"
              width="24" height="24" />
          }
          <span class="sidebar-item-text">{{ item.label }}</span>
        </a>
      </li>
    }
  </ul>
</div>
</div>